import { createStyles } from '@/contexts/theme-context';
import { PRICING_TABLE_LAYOUT } from '@/experiences/sales-portal/domain/pricing/constants';
import { ViewStyle } from 'react-native';

export const usePricingCellAlignmentStyles = createStyles((theme) => ({
  delta: {
    alignItems: 'flex-end',
    paddingRight: theme.sk.spacing.spaceSmall,
  },
  numeric: {
    alignItems: 'flex-end',
    paddingRight:
      theme.sk.spacing.spaceSmall + PRICING_TABLE_LAYOUT.SORT_ARROW_WIDTH,
  },
}));

interface AlignmentStyles {
  delta: ViewStyle;
  numeric: ViewStyle;
}

export const getCellAlignmentStyle = ({
  isDelta,
  isLeftAligned,
  styles,
}: {
  isDelta: boolean;
  isLeftAligned: boolean;
  styles: AlignmentStyles;
}): ViewStyle | undefined => {
  if (isLeftAligned) {
    return undefined;
  }
  if (isDelta) {
    return styles.delta;
  }
  return styles.numeric;
};
